import { array as codecArray } from 'purify-ts/Codec';
import { makeResponses } from '../response_factory';
import { utils as coreUtils, paginated, requestParams } from '@codegrade/api-core';
import { AcceptQuarantinedRegistrationData, DenyQuarantinedRegistrationData, QuarantinedRegistration, } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
const makeResult = coreUtils.makeResult;
// eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function quarantinedRegistration(config) {
    const acceptResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const denyResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const getAllResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(QuarantinedRegistration))),
    });
    return Object.freeze({
        /**
         * Accept quarantined registrations.
         *
         * @param arg The arguments to the function.
         * @param arg.quarantinedRegistrationId Registration id to accept.
         * @param arg.requestBody The body of the request.
         * @returns An empty response with return code 204
         */
        accept: async ({ quarantinedRegistrationId, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/quarantined_registrations/${quarantinedRegistrationId}/accept`, acceptResponse.v, JSON.stringify(AcceptQuarantinedRegistrationData.encode(requestBody)));
            return result;
        },
        /**
         * Deny quarantined registrations.
         *
         * @param arg The arguments to the function.
         * @param arg.quarantinedRegistrationId Registration id to accept.
         * @param arg.requestBody The body of the request.
         * @returns An empty response with return code 204
         */
        deny: async ({ quarantinedRegistrationId, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/quarantined_registrations/${quarantinedRegistrationId}/deny`, denyResponse.v, JSON.stringify(DenyQuarantinedRegistrationData.encode(requestBody)));
            return result;
        },
        /**
         * List quarantined registrations.
         *
         * @param arg The arguments to the function.
         * @param arg.pageSize The size of a single page, maximum is 100.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns Paginated list of quarantined registrations.
         */
        getAll: async ({ pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/quarantined_registrations/`, getAllResponse.v, undefined, {
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
    });
}
